export const SET_PAN = "SET_PAN";
export const SET_SETTINGS = "SET_SETTINGS";
export const SET_CUSTOM_MEN = "SET_CUSTOM_MEN";
export const SET_AVATAR = "SET_AVATAR";
